import { Trans } from "react-i18next";
import heckgarage from "../assets/images/heckgarage.jpg";
import wohoheck2 from "../assets/images/wohoheck_2.jpg";
import heckgarageWomo2 from "../assets/images/heckgarage_womo_2.jpg";
import dsc from "../assets/images/dsc.png";
import holder from "../assets/images/holder.png";
import anwendung from "../assets/images/anwendung.png";
import womoheck4 from "../assets/images/womoheck_42.png";
import WoMoHeck from "../assets/images/WoMoHeck.jpg";
import WoMoHeck3 from "../assets/images/WoMoHeck_3.png";
import WoMoHeck5 from "../assets/images/WoMoHeck_5.webp";
import heckgarageWomoDsc from "../assets/images/heckgarage_womo_dsc.jpg";
import heckgarageWomoDsc3 from "../assets/images/heckgarage_womo_dsc_3.jpg";
import heckgarageWomoDsc4 from "../assets/images/heckgarage_womo_dsc_4.jpg";

const TeasersSection = () => {
  return (
    <div className="px-6 mt-24 max-w-screen-2xl mx-auto 2xl:px-0">
      <h2 className="font-Roboto font-normal text-4xl leading-10 text-allsafe-blue mb-4">
        <Trans i18nKey="ourProductRange">Unser Sortiment</Trans>
      </h2>
      <section className="flex flex-col items-stretch lg:flex-row lg:space-x-6 mb-24">
        <div className="lg:basis-1/3">
          <h3 className="font-Roboto font-normal text-2xl text-allsafe-blue">
            <Trans i18nKey="airlineRails">Airline Schienen</Trans>
          </h3>
          <p className="font-Roboto font-normal my-6">
            <Trans i18nKey="airline_rail_base_infinite_options">
              Die Airline-Schiene ist die Basis für einen Baukasten mit fast
              unendlich vielen Möglichkeiten. Sie bietet eine hohe Belastbarkeit
              bei gleichzeitig geringem Gewicht, einfacher Reinigung und
              ergonomischer Gestaltung.
            </Trans>
          </p>
          <p className="font-Roboto font-normal mb-6">
            <Trans i18nKey="airlineRailBaseInfiniteOptions">
              Achten Sie deshalb auf originale allsafe Airline-Schienen: Nur im
              allsafe-System passt alles perfekt zueinander und die Komponenten
              sind nach höchsten Automotive-Standards entwickelt und gefertigt.
            </Trans>
          </p>
          <p className="font-Roboto font-normal mb-4">
            <Trans i18nKey="allsafeExteriorRailEce324">
              Die allsafe Exterior-Schiene erfüllt derzeit als einzige
              Airline-Schiene im Markt die Anforderungen nach ECE 324 R26 und
              ist dank Eloxal-Oberfläche für die Montage außen am Fahrzeug
              geeignet.
            </Trans>
          </p>
          <p className="font-Roboto font-normal mb-4">
            <Trans i18nKey="weight300gPerMeter">
              Mit einem Gewicht von gerade mal 300 g pro Meter wiegt sie nur
              etwa die Hälfte einer original Airline-Schiene.
            </Trans>
          </p>
        </div>
        <div className="lg:basis-1/3 shrink-0 self-center">
          <div className="w-full">
            <img
              src={WoMoHeck3}
              alt="WoMoHeck_3"
              className="w-full h-full object-contain"
            />
          </div>
          <div className="w-full -mt-12 ml-4 lg:-mt-6 xl:-mt-10">
            <img
              src={WoMoHeck5}
              alt="WoMoHeck_5"
              className="w-full h-full object-contain"
            />
          </div>
          <ul className="mb-8 mt-4 lg:mb-0 lg:mt-0.5">
            <li className="font-Roboto font-normal text-base leading-6 text-center">
              <Trans i18nKey="airlineRailLightSemicylindrical">
                (1) Airline-Schiene light, halbrund
              </Trans>
            </li>
            <li className="font-Roboto font-normal text-base leading-6 text-center">
              <Trans i18nKey="airlineRailSpecialExterior">
                (2) Airline-Schiene Spezial, Exterior-Schiene
              </Trans>
            </li>
            <li className="font-Roboto font-normal text-base leading-6 text-center">
              <Trans i18nKey="miniAirlineRail">
                (3) Mini Airline-Schiene
              </Trans>
            </li>
          </ul>
        </div>
        <div className="lg:basis-1/3 lg:h-80">
          <img
            src={WoMoHeck}
            alt="WoMoHeck"
            className="h-full w-full object-cover"
          />
        </div>
      </section>
      <section className="relative mb-24">
        <h3 className="font-Roboto font-normal text-3xl text-allsafe-blue mt-8 mb-4 lg:mt-20">
          <Trans i18nKey="fittings">Fittinge</Trans>
        </h3>
        <div className="flex flex-col space-y-20 lg:flex-row lg:space-y-0 lg:space-x-6 lg:items-stretch">
          <div className="lg:w-1/3 flex flex-col space-y-6 justify-between">
            <h4 className="font-Roboto font-normal text-2xl text-allsafe-blue">
              <Trans>KERL Butler</Trans>
            </h4>
            <p className="font-Roboto font-normal text-base leading-6">
              <Trans i18nKey="kerlButlerPerformsAsExpected">
                KERL Butler macht seinem Namen alle Ehre: Er dient Ihnen bei
                fast jeder Transportaufgabe und sorgt stets für Ordnung. Er
                verbiegt und verdreht sich, genau so, wie Sie es wünschen. Und
                wenn Sie ihn einmal nicht benötigen, ist er mit einem Handgriff
                aus der Airline-Schiene entnommen.
              </Trans>
            </p>
            <div className="relative flex flex-col mb-16">
              <div className="lg:h-80">
                <img
                  src={heckgarageWomo2}
                  alt="heckgarage_womo_2"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-11 bg-allsafe-grey w-[120px] h-[107px] mr-4 self-end flex items-center justify-center 2xl:w-[191px] 2xl:h-[171px]">
                <img
                  src={holder}
                  alt="holder"
                  className="w-[90%] h-[90%] object-contain"
                />
              </div>
            </div>
          </div>
          <div className="lg:w-1/3 flex flex-col space-y-6 justify-between">
            <h4 className="font-Roboto font-normal text-2xl text-allsafe-blue">
              <Trans>KERL Caravan</Trans>
            </h4>
            <p className="font-Roboto font-normal text-base leading-6">
              <Trans i18nKey="kerlCaravanToolFreeInstallation">
                Der KERL Caravan wird ohne Werkzeug in die Airline-Schiene
                eingesetzt und verklemmt. Kunststoffboxen, Fahrradträger und
                verschiedene Behälter können mit einem Handgriff in der
                Airline-Schiene fixiert werden. Ideal für alles, was schnell
                ein- und wieder ausgebaut wird.
              </Trans>
            </p>
            <div className="flex flex-col mb-16">
              <div className="lg:h-80">
                <img
                  src={wohoheck2}
                  alt="wohoheck_2"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-11 bg-allsafe-grey w-[120px] h-[107px] mr-4 self-end flex items-center justify-center 2xl:w-[191px] 2xl:h-[171px]">
                <img
                  src={dsc}
                  alt="dsc"
                  className="w-[90%] h-[90%] object-contain"
                />
              </div>
            </div>
          </div>
          <div className="lg:w-1/3 flex flex-col space-y-6 justify-between">
            <h4 className="font-Roboto font-normal text-2xl text-allsafe-blue">
              <Trans i18nKey="kerlJimM8">KERL JIM M8</Trans>
            </h4>
            <p className="font-Roboto font-normal text-base leading-6">
              <Trans i18nKey="kerlJimM8InternalThread">
                Ein Innengewinde überall dort, wo Sie es brauchen. Und wenn Sie
                es morgen an einer anderen Stelle brauchen? Dann schieben Sie
                den KERL JIM M8 einfach dort hin. Oder Sie nehmen ihn mit einem
                Handgriff aus der Airline-Schiene heraus. KERL JIM M8 klappert
                nicht, fällt nicht un-beabsichtigt aus der Airline-Schiene
                heraus und steht nicht hervor. Ein kleines Befestigungs-Genie!
              </Trans>
            </p>
            <div className="relative flex flex-col mb-16 self-end">
              <div className="lg:h-80">
                <img
                  src={heckgarage}
                  alt="heckgarage"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-11 bg-allsafe-grey w-[120px] h-[107px] mr-4 self-end flex items-center justify-center 2xl:w-[191px] 2xl:h-[171px]">
                <img
                  src={anwendung}
                  alt="anwendung"
                  className="w-[80%] h-[80%] object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mb-24">
        <h3 className="font-Roboto font-normal text-3xl leading-10 text-allsafe-blue mb-4">
          <Trans i18nKey="gurte">Gurte</Trans>
        </h3>
        <h4 className="font-Roboto font-normal text-2xl text-allsafe-blue mb-4">
          <Trans i18nKey="kerl500ClampLockStrap">
            KERL 500 und Klemmschlossgurt
          </Trans>
        </h4>
        <div className="flex flex-col lg:flex-row lg:items-stretch lg:space-x-6 items-stretch">
          <div className="lg:basis-1/3 self-center">
            <p className="font-Roboto font-normal text-base leading-6 mb-6">
              <Trans i18nKey="clampLockStrapsWithKerl500">
                Klemmschlossgurte mit KERL-500-Beschlag sind die Universalgenies
                der Ladungssicherung. Mit ihnen können Sie fast alles schnell
                und einfach sichern: Egal ob Skiausrüstung, Campingmöbel oder
                Transportboxen – selbst Grills finden mit ihnen sicheren Halt
                während der Fahrt.
              </Trans>
            </p>
            <p className="font-Roboto font-normal text-base leading-6 mb-6">
              <Trans i18nKey="kerl500AvailableIndividually">
                Den KERL 500 gibt es natürlich auch lose. Warum wir den KERL 500
                genannt haben? Vielleicht auch, weil er Sie bei bestimmt 500
                verschiedenen Ladungssicherungs-Aufgaben unterstützt.
              </Trans>
            </p>
            <p className="font-Roboto font-normal text-base leading-6 mb-4">
              <Trans i18nKey="kerl500V2aRustResistant">
                Für die Exterior-Schiene und bei allen Einsätzen außen am
                Fahrzeug empfehlen wir den rostfreien KERL 500 V2A.
                Selbstverständlich passen KERL 500 und KERL 500 V2A in alle
                allsafe Airline-Schienen.
              </Trans>
            </p>
          </div>
          <div className="self-center lg:basis-1/3">
            <img
              src={womoheck4}
              alt="womoheck_4"
              className="w-full h-full object-contain"
            />
          </div>
          <div className="mt-6 lg:basis-1/3 self-center lg:mt-0">
            <img
              src={heckgarageWomoDsc4}
              alt="heckgarage_womo_dsc_4"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </section>
      <section className="mb-24">
        <h3 className="font-Roboto font-normal text-3xl leading-10 text-allsafe-blue mb-4">
          <Trans i18nKey="lockingRods">Sperrstangen</Trans>
        </h3>
        <h4 className="font-Roboto font-normal text-2xl text-allsafe-blue mb-4">
          <Trans i18nKey="kim4x4Airline">KIM 4x4 Airline</Trans>
        </h4>
        <div className="flex flex-col lg:flex-row lg:space-x-6 items-stretch">
          <div className="lg:basis-1/3">
            <p className="font-Roboto font-normal text-base leading-6 mb-6">
              <Trans i18nKey="kim4x4DualPurposeLockingRod">
                KIM 4x4 ist doppelt praktisch: Diese Sperrstange sichert zum
                einen Ihre wertvolle Ladung, zum anderen erweitern die
                serienmäßigen Airline-Schienen die Stau- und
                Befestigungsmöglichkeiten in Ihrer Heckgarage.
              </Trans>
            </p>
            <p className="font-Roboto font-normal text-base leading-6">
              <Trans i18nKey="cleverDetailsTwistLockOperatingStrap">
                Pfiffige Details wie die Verdrehsicherung und der Bediengurt
                erleichtern das Handling – und wenn KIM 4x4 einmal nicht
                benötigt wird, kann sie ganz einfach entnommen und an anderer
                Stelle eingesetzt werden.
              </Trans>
            </p>
          </div>
          <div className="lg:basis-1/3 mt-6 lg:h-80 lg:mt-0">
            <img
              src={heckgarageWomoDsc}
              alt="heckgarage_womo_dsc"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="lg:basis-1/3 mt-6 lg:h-80 lg:mt-0">
            <img
              src={heckgarageWomoDsc3}
              alt="heckgarage_womo_dsc_3"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeasersSection;
